interface SearchItem {
    [key: string]: any;
}

interface SearchParams {
    items: SearchItem[];
    searchText: string;
    keys: string[];
}

export default class SearchService {
    public static search(searchParams: SearchParams): SearchItem[] {
        const normalizesdSearchText = searchParams.searchText.toLowerCase();
        return searchParams.items.filter(item =>
            searchParams.keys.some(key => 
            String(item[key]).toLowerCase().includes(normalizesdSearchText))
        );
    }
}
